import {RetailerMap} from "./retailer-map";

// retailersData is injected into the HTML
/* global retailersData */

/** @type {number} */ const ADDRESS_SELECTION_ZOOM = 10;

window.initRetailerMap = function () {
    new RetailerMap(
        retailersData,
        document.getElementById('map'),
        document.getElementById('retailerAddress'),
        document.getElementById('checkbox-retailer-commercial'),
        document.getElementById('checkbox-retailer-private'),
        ADDRESS_SELECTION_ZOOM,
    );
};
